import { makeAutoObservable, runInAction } from "mobx";
import { IMasterPostDetails, IMasterService, MasterProfileService } from "../MasterProfile/MasterProfileService";

export class MasterPostStore {
  public Post: IMasterPostDetails | null = null;

  public IsLoading = false;
  public IsDeleting = false;
  public Error = "";

  public IsEditSheetOpen = false;
  public IsDeleteSheetOpen = false;

  public Services: IMasterService[] = [];

  public IsUpdating = false;
  public UpdateError = "";

  public EditTitle = "";
  public EditDescription = "";
  public EditServiceId: number | null = null;

  public ImageFile: File | null = null;
  public ImagePreviewUrl = "";

  constructor() {
    makeAutoObservable(this);
  }

  public async load(id: number) {
    this.IsLoading = true;
    this.Error = "";

    try {
      const post = await MasterProfileService.GetPost(id);

      runInAction(() => {
        this.Post = post;

        this.EditTitle = post.title;
        this.EditDescription = post.description;
        this.EditServiceId = post.serviceId;
      });
    } catch {
      runInAction(() => {
        this.Error = "Не удалось загрузить пост";
      });
    } finally {
      runInAction(() => {
        this.IsLoading = false;
      });
    }
  }

  public openEditSheet() {
    this.IsEditSheetOpen = true;
  }

  public closeEditSheet() {
    this.IsEditSheetOpen = false;
  }

  public openDeleteSheet() {
    this.IsDeleteSheetOpen = true;
  }

  public closeDeleteSheet() {
    this.IsDeleteSheetOpen = false;
  }

  public async deletePost(onSuccess: () => void) {
    if (!this.Post) return;

    this.IsDeleting = true;

    try {
      await MasterProfileService.DeletePost(this.Post.id);
      onSuccess();
    } catch {
      runInAction(() => {
        this.Error = "Не удалось удалить пост";
      });
    } finally {
      runInAction(() => {
        this.IsDeleting = false;
      });
    }
  }

  public setEditTitle(value: string) {
    this.EditTitle = value;
  }

  public setEditDescription(value: string) {
    this.EditDescription = value;
  }

  public setImage(file: File) {
    this.ImageFile = file;
    this.ImagePreviewUrl = URL.createObjectURL(file);
  }

  public async updatePost(onSuccess: () => void) {
    if (!this.Post) return;

    if (!this.EditTitle.trim()) {
      this.UpdateError = "Введите название поста";
      return;
    }

    this.IsUpdating = true;
    this.UpdateError = "";

    try {
      const updatedPost = await MasterProfileService.UpdatePost(this.Post.id, this.Post.serviceId, this.EditTitle.trim(), this.EditDescription.trim(), this.ImageFile);

      runInAction(() => {
        this.Post = updatedPost;
        this.EditTitle = updatedPost.title;
        this.EditDescription = updatedPost.description;
        this.EditServiceId = updatedPost.serviceId;
        this.ImageFile = null;
        this.ImagePreviewUrl = "";
      });

      onSuccess();
    } catch {
      runInAction(() => {
        this.UpdateError = "Не удалось сохранить пост";
      });
    } finally {
      runInAction(() => {
        this.IsUpdating = false;
      });
    }
  }
}
